import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@motorway/mw-highway-code';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { IncodeFooter } from '../components/IncodeFooter';

import styles from '../IncodeSdkPage.scss';

const IS_DEV = process.env.NODE_ENV === 'development';

export const IncodeCaptureDevHelper = ({ to }: { to: string }) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const location = useLocation();

  if (!IS_DEV) {
    return null;
  }

  const isPostSaleFlow = location.pathname.includes('automated-docs-upload');
  const path = isPostSaleFlow ? 'automated-docs-upload' : 'early-docs-upload';

  return (
    <IncodeFooter className={styles.devHelper}>
      <Button as={Link} label={'Bypass for testing'} to={`/${vehicle.vrm}/${path}${to}`} />
    </IncodeFooter>
  );
};
